import './ImageLayout.css'

interface Props
{
    src?: string
    children: React.ReactNode
}

function ImageLayout(props: Props)
{
    return (
        <div className="image-layout-container">
            <div className="image-layout-content">
                {props.children}
            </div>
            <div className="image-layout-image-container" >
                <img src={props.src} alt='Error' className='image-layout-image' />
            </div>
        </div>
    )
}

export default ImageLayout